import { deriveSizes } from '../../../../../../lib/utils'
import { Product, Variant } from '../../../../../../types/graphql'

/**
 * @deprecated Use your own types based on your query's gen typed data.
 */
export type ProductPageProduct = Product & {
  handle: string
}

/**
 * @deprecated Use your own types based on your query's gen typed data.
 */
export namespace ProductPageProduct {
  export function getVariants(product: ProductPageProduct) {
    return product.variants ?? []
  }
  export function getSizes(product: ProductPageProduct, sizes: string[]) {
    const variants = ProductPageProduct.getVariants(product)
    return deriveSizes(variants, sizes)
  }
  export function getSelectedSize(
    product: ProductPageProduct,
    sizes: string[],
    selectedVariant?: Variant
  ) {
    const derivedSizes = getSizes(product, sizes)
    return derivedSizes.find(size => size.shorthand === selectedVariant?.size)
  }

  export function getSelectedColorKey(product: ProductPageProduct) {
    return product.colorInfo?.rawName
  }

  export function isProductEmbroiderable(product: ProductPageProduct) {
    return !!product?.embroidery?.length
  }

  export function isProductFinalSale(product: ProductPageProduct) {
    return !!product?.finalSale
  }
}
